import { render, staticRenderFns } from "./ImmediateActivityDialog.vue?vue&type=template&id=7fc5ef12&scoped=true"
import script from "./ImmediateActivityDialog.vue?vue&type=script&lang=js"
export * from "./ImmediateActivityDialog.vue?vue&type=script&lang=js"
import style0 from "./ImmediateActivityDialog.vue?vue&type=style&index=0&id=7fc5ef12&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc5ef12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc5ef12')) {
      api.createRecord('7fc5ef12', component.options)
    } else {
      api.reload('7fc5ef12', component.options)
    }
    module.hot.accept("./ImmediateActivityDialog.vue?vue&type=template&id=7fc5ef12&scoped=true", function () {
      api.rerender('7fc5ef12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/immediate/ImmediateActivityDialog.vue"
export default component.exports